import React from 'react';
import BlockContent from '../../../../../BlockContent';
import { VehicleInspectionContext } from '../VehicleInspection.types';
import * as S from './ContextPanel.styles';

interface ContextPanelProps {
  context: VehicleInspectionContext;
  badgeText?: string;
}

export const ContextPanel = ({ context, badgeText }: ContextPanelProps) => {
  const { showVehicleBadge, title, body, ctaButton } = context;
  const ctaButtonText = ctaButton?.text || title;
  const ctaButtonBlock =
    ctaButton && ctaButtonText
      ? {
          ...ctaButton,
          _type: 'ctaButtonBody',
          text: ctaButtonText,
          url: ctaButton.url || '',
          blank: Boolean(ctaButton.blank),
        }
      : undefined;

  return (
    <S.ContextBoxWrapper>
      {showVehicleBadge && badgeText && <S.VehicleBadge text={badgeText} color="secondary" />}
      {title && <S.ContextTitle variant="headlineXXS">{title}</S.ContextTitle>}
      {body && body.length > 0 && (
        <S.ContextBody>
          <BlockContent value={body} />
        </S.ContextBody>
      )}
      {ctaButtonBlock && (
        <S.ContextCta>
          <BlockContent value={[ctaButtonBlock]} />
        </S.ContextCta>
      )}
    </S.ContextBoxWrapper>
  );
};
